import { getColoredIconStyles } from './variantStyles/coloredIcon';
import { getColoredImageStyles } from './variantStyles/coloredImage';
import { getDefaultIconStyles } from './variantStyles/defaultIcon';
import { getDefaultImageStyles } from './variantStyles/defaultImage';
import { getNeutralIconStyles } from './variantStyles/neutralIcon';
import { getNeutralImageStyles } from './variantStyles/neutralImage';
export const getCommercialCardStyles = (FOUNDATIONS, FONT) => {
    return {
        ...getDefaultImageStyles(FOUNDATIONS, FONT),
        ...getNeutralImageStyles(FOUNDATIONS, FONT),
        ...getColoredImageStyles(FOUNDATIONS, FONT),
        ...getDefaultIconStyles(FOUNDATIONS, FONT),
        ...getNeutralIconStyles(FOUNDATIONS, FONT),
        ...getColoredIconStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map